/**
 * CheckboxErrorCategories — F-007 Phase 4 (IMPL-P4-005).
 *
 * Multi-select delle categorie di segnalazione errore. Renderizza
 * `SEGNALAZIONE_REASONS` (constante esportata da `@app/shared` Phase 1) come
 * checkbox con label IT-IT da `SEGNALAZIONE_REASON_LABELS`.
 *
 * Componente "controlled": riceve `selected` e propaga `onChange(next)`.
 */
import {
  SEGNALAZIONE_REASONS,
  SEGNALAZIONE_REASON_LABELS,
  type SegnalazioneReason,
} from '@app/shared';

interface CheckboxErrorCategoriesProps {
  selected: SegnalazioneReason[];
  onChange: (reasons: SegnalazioneReason[]) => void;
  disabled?: boolean;
}

export function CheckboxErrorCategories({
  selected,
  onChange,
  disabled = false,
}: CheckboxErrorCategoriesProps) {
  const toggle = (reason: SegnalazioneReason, checked: boolean) => {
    if (checked) {
      if (selected.includes(reason)) return;
      onChange([...selected, reason]);
    } else {
      onChange(selected.filter((r) => r !== reason));
    }
  };

  return (
    <fieldset className="space-y-2" disabled={disabled}>
      <legend className="sr-only">Categorie di segnalazione</legend>
      {SEGNALAZIONE_REASONS.map((reason) => {
        const inputId = `segnalazione-${reason}`;
        return (
          <label
            key={reason}
            htmlFor={inputId}
            className="flex cursor-pointer items-center gap-2 text-sm"
          >
            <input
              id={inputId}
              type="checkbox"
              className="h-4 w-4 rounded border-input"
              checked={selected.includes(reason)}
              onChange={(e) => toggle(reason, e.target.checked)}
              disabled={disabled}
            />
            <span>{SEGNALAZIONE_REASON_LABELS[reason] ?? reason}</span>
          </label>
        );
      })}
    </fieldset>
  );
}
